module.exports = __webpack_public_path__ + "img/map_icon.72f2aea5.svg";